import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import { SignUpLink } from '../SignUp';
import { PasswordForgetLink } from '../PasswordForget';
import { withFirebase } from '../../components/Firebase';
import withAuthorization from '../../components/Session/withAuthorization'
import withAuthDomain from '../../components/Session/withAuthDomain'
import * as ROUTES from '../../constants/routes';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';




const condition = authUser => authUser==null;


 const SignInPage=(props) => {
  const classes = useStyles();
  //const [textSignIn,setTextSignIn]=React.useState("Sign In");
  return (
    
  <Container component="main" maxWidth="xs">
    <CssBaseline />
    <div className={classes.paper}>
      <Avatar className={classes.avatar}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        Sign in
      </Typography>
      <SignInForm classes={classes}/>
    </div>
    <Box mt={5}>
      
    </Box>
  </Container>
  )
};
export default withAuthDomain(condition,ROUTES.HOME,"online-asset-manager","")(SignInPage);
//export default withAuthorization(condition,ROUTES.HOME)(SignInPage);
//export default SignInPage;



const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  alert: {
    color: 'red',
  },
}));

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
  textSignIn:"Sign In"
};



class SignInFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = {...INITIAL_STATE };
    
  }

  onSubmit = event => {
    const { email, password } = this.state;
    //console.log("onSubmit")
    this.setState({textSignIn:"Loading...",error:null})
    this.props.firebase
      .doSignInWithEmailAndPassword(email, password)
      .then((auth) => {
        //console.log("then")
        //this.setState({ ...INITIAL_STATE });
        //this.props.history.push(ROUTES.HOME);
        this.props.firebase.fs.doc("users/"+auth.user.uid).set({domainView:"online-asset-manager",companyViewId:"",branchViewId:""},{merge:true})
        .then(()=>{
          this.setState({ ...INITIAL_STATE });
          this.props.history.push(ROUTES.HOME);
        })
        .catch(error=>{
          this.setState({textSignIn:"Sign In"})
          this.setState({ error });
        })
      })
      .catch(error => {
        //console.log("error")
        this.setState({textSignIn:"Sign In"})
        this.setState({ error });
      });

    //event.preventDefault();
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  
  
  render() {
    
    const { email, password, error,textSignIn } = this.state;

    const isInvalid = password === '' || email === '';
    
    return (

      <div className={this.props.classes.form} >
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={this.onChange}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={this.onChange}
          />
          {/*}
          <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="Remember me"
          />
          */}
          <Button
            type="submit"
            onClick={this.onSubmit}
            fullWidth
            variant="contained"
            color="primary"
            className={this.props.classes.submit}
            disabled={isInvalid}
          >
            {textSignIn}
          </Button>
          {error && <p className={this.props.classes.alert}>{error.message}</p>}
          <Grid container>
            <Grid item xs>
              <PasswordForgetLink />
            </Grid>
            <Grid item>
              <SignUpLink />
            </Grid>
          </Grid>
        </div>

    );
  }
}


/*

className={classes.form}

className={classes.submit}


<Link href="#" variant="body2" onClick={handleClick}>
                Forgot password?
              </Link>
<Link href="#" variant="body2" onClick={handleClick}>
                {"Don't have an account? Sign Up"}
              </Link>


      <form onSubmit={this.onSubmit}>
        <input
          name="email"
          value={email}
          onChange={this.onChange}
          type="text"
          placeholder="Email Address"
        />
        <input
          name="password"
          value={password}
          onChange={this.onChange}
          type="password"
          placeholder="Password"
        />
        <button disabled={isInvalid} type="submit">
          Sign In
        </button>

        {error && <p>{error.message}</p>}
      </form>


              */

const SignInLink = () => (
  <p>
    Already have an account? <Link to={ROUTES.SIGN_IN}>Sign In</Link>
  </p>
);



const SignInForm = compose(
  withRouter,
  withFirebase,
)(SignInFormBase);

//export default SignInPage;

export { SignInForm ,SignInLink};